import gql from 'graphql-tag';

export const CommentsSectionFabricQuerySaveComment = gql`
	mutation CommentsSectionFabricQuerySaveComment($params: ExperimentalFabricCommentInput)
	@experimental
	@SLA {
		experimentalSaveFabricComment(params: $params) {
			id
			ancestors {
				id
			}
			container {
				id
			}
			extensions {
				location
			}
		}
	}
`;
